<template>
    <div>
        <modal class="no-right no-close" :display="modalStatus.bizNoRight" @modalStatus="closeModal" >
            <div class="no-right-wrap">
                <img class="alarm-img" src="@/assets/img/icon/modal_alarm.svg" alt="">
                <div class="content">
                    您沒有此權限
                </div>
            </div>
            <div class="btn-group">
                <button class="default-button confirm" @click="closeModal">回個人首頁</button>
            </div>
        </modal>
    </div>
</template>
<script>
import Modal from '@/components/widge/Modal.vue';
import { mapGetters } from 'vuex'

export default {
    data () {
        return {
        }
    },
    methods: {
        closeModal: function () {
            this.$router.push({name: 'bizHomeDefault'})
            this.$store.dispatch('setModalStatus', {state: false, type: 'bizNoRight'})
        },
    },
    computed: {
        isOpen: function () {
            if(this.value){
                return '開啟'
            }else{
                return '關閉'
            }
        },
        ...mapGetters({
            modalStatus: 'GET_MODAL_STATUS',
        })
    },
    components: {
        Modal,
    }
}
</script>
<style lang="scss"  >
    #modal.no-right{
        .error{
            right: 0px;
            top: -24px;
            left: unset;
        }
        .modal-content{
            width: 448px;
            height: 302px;
            padding: 0 !important;
            .detail{
                >h1{
                    margin-top: 32px;
                    margin-bottom: 42px;
                }
                .no-right-wrap{
                    padding: 0 32px 0 32px;
                    text-align: center;
                    .alarm-img{
                        margin-top: 40px;
                        margin-bottom: 18px;
                    }
                    .content{
                        font-size: 24px;
                        font-weight: 500;
                        margin-bottom: 60px;
                    }
                }
            }
            
            .btn-group{
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                height: 84px;
                box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                border-radius:  0 0 20px 20px;
                margin: 0 auto;
                button{
                    width: 200px;
                    height: 44px;
                }
            }
        }
    }
    #modal.no-close{
        .cancle{
            display: none;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/widges/modals/noRight.vue